module.exports = __webpack_public_path__ + "img/pro_five_4.12ef65d1.jpg";